const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Digits only — require a plausible international length. */
const MIN_PHONE_DIGITS = 8;
const MAX_PHONE_DIGITS = 15;

export type CheckoutGuestFields = {
  fullName: string;
  email: string;
  phone: string;
  gender: string;
};

export type CheckoutFieldErrors = Partial<
  Record<keyof CheckoutGuestFields, string>
>;

export const isValidEmail = (email: string): boolean =>
  EMAIL_PATTERN.test(email.trim());

export const isValidPhone = (phone: string): boolean => {
  const digits = phone.replace(/\D/g, '');
  return digits.length >= MIN_PHONE_DIGITS && digits.length <= MAX_PHONE_DIGITS;
};

export const validateCheckoutGuest = (
  guest: CheckoutGuestFields,
): CheckoutFieldErrors => {
  const errors: CheckoutFieldErrors = {};

  if (!guest.fullName.trim()) {
    errors.fullName = 'Full name is required.';
  }
  if (!guest.gender.trim()) {
    errors.gender = 'Gender is required.';
  }
  if (!guest.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!isValidEmail(guest.email)) {
    errors.email = 'Enter a valid email address.';
  }
  if (!guest.phone.trim()) {
    errors.phone = 'Phone number is required.';
  } else if (!isValidPhone(guest.phone)) {
    errors.phone = 'Enter a valid phone number.';
  }

  return errors;
};

export const firstCheckoutErrorMessage = (
  errors: CheckoutFieldErrors,
): string | null => {
  const first = Object.values(errors).find(Boolean);
  return first ?? null;
};
